const subscriptions = {
  download_title: 'Download subscriptions',
  export_to: 'Export',
  all: 'All',
  selected: 'Selected',
  result: 'Result',
  delivery: 'Delivery',
  by_email: 'By email',
};

export default subscriptions;
